import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { TranslocoService } from '@ngneat/transloco';
import { KpoCardInterface } from '../interfaces/kpo-card-interface';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  get storageEngine() {
    if (Capacitor.isNativePlatform()) {
      return localStorage;
    } else {
      return sessionStorage;
    }
  }

  constructor(private translocoService: TranslocoService) {}

  public set(key: string, value: any): void {
    if (value == null) {
      return;
    }

    this.storageEngine.setItem(key, JSON.stringify(value));
  }

  public get(key: string): any {
    const unparsedValue = this.storageEngine.getItem(key);
    return this.parseStorageValue(unparsedValue);
  }

  public setPersistent(key: string, value: any): void {
    if (value == null) {
      return;
    }

    localStorage.setItem(key, JSON.stringify(value));
  }

  public getPersistent(key: string): any {
    const unparsedValue = localStorage.getItem(key);
    return this.parseStorageValue(unparsedValue);
  }

  public clear(): void {
    const cookieConsent = this.getPersistent('cookieConsent');

    localStorage.clear();
    sessionStorage.clear();

    // Recover persistent variables
    this.setPersistent('lang', this.translocoService.getActiveLang());
    this.setPersistent('cookieConsent', cookieConsent);
  }

  public getCardById(id: string): KpoCardInterface {
    const cards: KpoCardInterface[] = this.get('kpoCards');
    return cards?.find((card) => card.bdO_UUID === id);
  }

  private parseStorageValue(unparsedValue: string): any {
    if (unparsedValue) {
      try {
        const value = JSON.parse(unparsedValue);
        if (value && (typeof value === 'object' || typeof value === 'string')) {
          return value;
        }
      } catch (e) {}

      return unparsedValue;
    } else {
      return null;
    }
  }
}
